import Spinner from '../../../Spinner';
import {FormattedMessage} from 'react-intl';
import Messages from './Form.messages';
import {withIntl} from '../../../Intl';

class Form extends React.Component {
    error() {
        if (this.props.status === 'error') {
            return <div className="form-control-feedback small text-danger mt-2 text-center">
                <FormattedMessage {...Messages.failed_to_signup}/>
            </div>
        }
    }

    success() {
        if (this.props.status === 'success') {
            return <div className="form-control-feedback small text-success mt-2 text-center">
                <FormattedMessage {...Messages.signup_success}/>
            </div>
        }
    }

    buttonText() {
        if (this.props.status === 'loading') {
            return <Spinner/>
        }

        return <i className="fa fa-chevron-right"/>
    }

    loggedInButtonText() {
        if (this.props.status === 'loading') {
            return <Spinner/>
        }

        return <span><FormattedMessage {...Messages.logged_in_cta}/></span>
    }

    loggedInForm() {
        return <div>
            <div className="text-center">
                <div>
                    <button
                        className={"btn btn-primary btn-sm" + ((this.props.status === 'loading') ? " disabled" : "")}
                        onClick={this.props.onSubmit}
                    >
                        {this.loggedInButtonText()}
                    </button>
                </div>
                {this.error()}
                {this.success()}
                <div>
                    <small>
                        <small>
                            <FormattedMessage {...Messages.not_email} values={{email: this.props.sessionEmail}}/>
                            &nbsp;<a href="#" onClick={this.props.resetSessionEmail}><FormattedMessage {...Messages.use_different_email}/></a>
                        </small>
                    </small>
                </div>
            </div>
        </div>
    }

    render() {
        const {intl} = this.props;

        if (this.props.sessionEmail) {
            return this.loggedInForm();
        }

        return <form onSubmit={this.props.onSubmit}>
            <div className="input-group">
                <input
                    className="form-control bg-white small"
                    placeholder={intl.formatMessage(Messages.type_your_email)}
                    type="email"
                    name="email"
                    required="required"
                    onChange={this.props.setEmail}
                    value={this.props.email}/>
                <span className="input-group-btn">
                    <button type="submit"
                            className={"btn btn-primary btn-primary" + ((this.props.status === 'loading') ? " disabled" : "")}
                            style={{width: '38px'}}>
                        <small>{this.buttonText()}</small>
                    </button>
                </span>
            </div>
            {this.error()}
            {this.success()}
        </form>
    };
}

export default withIntl(Form);
